import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { LocalizedDatePipe } from '~app/core/locale/localized-date.pipe';
import { DownloadDecisionDocument } from '../store/public-member-search.actions';
import { DecisionDocument, ExerciseStatus, InscriptionStatus, InsuranceStatusCode, PublicMemberInfos, SpecialtyType } from '../store/public-member-search.model';

@Component({
  selector: 'odq-public-member-info-v2',
  templateUrl: './public-member-info-v2.component.html',
  styleUrls: ['./public-member-info-v2.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class PublicMemberInfoV2Component implements OnInit {

  @Input()
  memberPublicInfos: PublicMemberInfos

  @Input()
  specialtytypes: SpecialtyType[];

  @Input()
  insuranceStatusCodes: InsuranceStatusCode[];

  isNotAuthorized: boolean = false;

  today = new Date();
  displayedColumns: string[] = ['recordNumber', 'decisionDate', 'publicDecisionType', 'documents'];
  constructor(public translate: TranslateService, private store: Store, private datePipe: LocalizedDatePipe) { }

  ngOnInit(): void {
    this.isNotAuthorized = this.memberPublicInfos.effectiveInscriptionStatus === InscriptionStatus.NotRegistered ||
      (this.memberPublicInfos.effectiveExerciseStatus === ExerciseStatus.Inactive &&
        this.memberPublicInfos.effectiveInscriptionStatus === InscriptionStatus.Registered);
  }

  getInsuranceStatus(): string {
    const code = this.memberPublicInfos.effectiveInsuranceStatusCode;
    return this.insuranceStatusCodes?.find(isc => isc.code === code)?.description[this.translate.currentLang] || '';
  }

  getSpecialtyTypeLabelForId(id: string): string {
    return this.specialtytypes?.find(st => st.id === id)?.description[this.translate.currentLang] || '';
  }

  isActive(): boolean {
    return (
      this.memberPublicInfos.effectiveExerciseStatus === ExerciseStatus.Active &&
      this.memberPublicInfos.effectiveInscriptionStatus === InscriptionStatus.Registered
    );
  }

  isRegistered(): boolean {
    return (
      this.memberPublicInfos.effectiveInscriptionStatus === InscriptionStatus.Registered
    );
  }

  printMemberInfos() {
    window.print();
  }

  downloadDocument(document: DecisionDocument) {
    this.store.dispatch(new DownloadDecisionDocument(document));
  }

  showMemberSpecification() {
    return this.isActive() &&
      (this.memberPublicInfos?.isAnesthesiaPrivateClinic ||
        this.memberPublicInfos?.isAnesthesiaHospital ||
        this.memberPublicInfos?.isHomeVisit ||
        this.memberPublicInfos?.isParticularMedicalCondition ||
        this.memberPublicInfos?.isReducedMobility ||
        this.memberPublicInfos?.isSleepApnea ||
        this.memberPublicInfos?.isLiftPerson)
  }

  isPermitSuspended(): boolean {
    return this.memberPublicInfos?.permitType?.fr === 'Suspendu';
  }

  getSortedLimitations() {
    if (!this.memberPublicInfos?.limitations) {
      return [];
    }
    return [...this.memberPublicInfos.limitations].sort((a, b) => {
      const dateA = new Date(a.startAt);
      const dateB = new Date(b.startAt);
      return dateB.getTime() - dateA.getTime(); // Descending order
    });
  }

  getSortedDecisions() {
    if (!this.memberPublicInfos?.decisions) {
      return [];
    }
    return [...this.memberPublicInfos.decisions].sort((a, b) => {
      const dateA = new Date(a.decisionDate);
      const dateB = new Date(b.decisionDate);
      return dateB.getTime() - dateA.getTime(); // Descending order
    });
  }

  convertRecordNumber(recordNumber: string): string {
    if (recordNumber?.length == 9) {
      return `${recordNumber.slice(0, 2)}-${recordNumber.slice(
        2,
        4
      )}-${recordNumber.slice(4, 9)}`;
    } else if (recordNumber?.length == 11) {
      return `${recordNumber.slice(0, 2)}-${recordNumber.slice(
        2,
        6
      )}-${recordNumber.slice(6, 11)}`;
    } else if (recordNumber?.length == 13) {
      return `${recordNumber.slice(0, 2)}-${recordNumber.slice(
        2,
        6
      )}-${recordNumber.slice(6, 13)}`;
    } else return recordNumber;
  }

  inactivityDate(): string {
    var inactiveSince = this.translate.instant(
      "memberPublicInfos.inactiveSince"
    );

    return `${inactiveSince} ${this.datePipe.transform(this.memberPublicInfos?.effectiveStatusDate, 'mediumDate')}`;
  }
}
